/**
 * @description 国际化
 * @date 2023-11-13 19:33:13
 * @author 2028
 */
export default {
  namespaced: true,
  state: {
    showLang: window.config.showLang,
    lang: localStorage.getItem('lang') || 'zh-CN', // 选中的语言
    langList: [
      { name: '简体中文', value: 'zh-CN' },
      { name: '繁體中文', value: 'zh-TW' },
      { name: 'English', value: 'en-US' }
    ]
  },
  mutations: {
    setShowLang(state, flag) {
      state.showLang = flag
    },
    setLang(state, lang) {
      state.lang = lang
    }
  },
  actions: {}
}
